import React from "react";
import styles from "../../styles/report/reporthead.module.scss";
import { useNavigate, useLocation } from "react-router-dom";
import { ApiEndpoints, LocalStorageKeys } from "../../core";

const ClientReportHead = ({ report }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const formatTestDateTime = (dateTimeString) => {
    if (!dateTimeString) return "--";

    const date = new Date(dateTimeString);
    const dateStr = date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, ".");

    return `${dateStr} `;
  };

  const currentReport = report?.[0];

  const clientData = {
    id: currentReport?.client?._id,
    name: currentReport?.client?.name || "-",
    clientId: currentReport?.client?.code || "-",
    gender:
      currentReport?.client?.gender?.charAt(0) +
        currentReport?.client?.gender?.slice(1).toLowerCase() || "-",
    dob: currentReport?.client?.dob,
    lastTestDateTime: formatTestDateTime(
      currentReport?.client?.lastReportTestedAt
    ),
    year: currentReport?.year || "-",
  };

  const handleDownloadPDF = async () => {
    console.log("Download PDF clicked");

    const clientId = clientData?.id;
    if (!clientId) {
      console.error("Client ID not found.");
      return;
    }
    const token = localStorage.getItem(LocalStorageKeys.coachToken);

    const downloadUrl = `${ApiEndpoints.baseApiURL}/fitness-report/download/client/${clientId}`;

    try {
      const response = await fetch(downloadUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }); 
      if (!response.ok) {
        throw new Error("Failed to fetch PDF");
      }

      const blob = await response.blob(); // ✅ Convert response to blob
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `${clientData.name}-${clientData.year}-fitness-report.pdf`;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(blobUrl); // ✅ Clean up
    } catch (error) {
      console.error("PDF download failed:", error);
    }
  };

  const handleBack = () => {
    const currentPath = location.pathname;
    const clientId = clientData?.id;

    if (currentPath === `/fitnes-report-preview-detailed/${clientId}`) {
      navigate(`/fitnes-report-preview-summary/${clientId}`);
    } else {
      navigate(`/client-report/${clientId}`);
    }
  };

  return (
    <div className={styles.container}>
      {/* Header Section */}
      <div className={styles.buttonGroup}>
        <div className={styles.buttonGroupchildone}>
          <h1 className={styles.title}>CLIENT REPORT</h1>
        </div>
        <div className={styles.buttonGroupchildtwo}>
          <button onClick={handleDownloadPDF} className={styles.downloadButton}>
            Download PDF
          </button>
          <button onClick={handleBack} className={styles.backButton}>
            Back
          </button>
        </div>
      </div>

      {/* Client Information Section */}
      <div className={styles.clientInfo}>
        <div className={styles.infoGrid}>
          <div className={styles.infoItem}>
            <span className={styles.label}>Client Name:</span>
            <span className={styles.value}>{clientData.name}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.label}>Client ID:</span>
            <span className={styles.value}>{clientData.clientId}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.label}>Gender:</span>
            <span className={styles.value}>{clientData.gender}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.label}>DOB:</span>
            <span className={styles.value}>{clientData.dob}</span>
          </div>
          <div className={styles.infoItem}>
            <span className={styles.label}>Last Test Date :</span>
            <span className={styles.value}>{clientData.lastTestDateTime}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientReportHead;
